const icons = {
  English: require('./flagEnglish.png'),
  Japanese: require('./flagJapan.png'),
  Chinese: require('./flagChaina.png'),
  Korean: require('./flagKoria.png'),
};
export default icons;
